'use strict'

const maybe = require('folktale/maybe')
const isPlainObject_ = require('lodash/isPlainObject')
const flatMap_ = require('lodash/flatMap')
const set_ = require('lodash/set')
const cloneDeep_ = require('lodash/cloneDeep')
const { shouldResolve } = require('dbsm-common/src/dataBindingFilterResolver')

const getComponentValue = ({ filterId }, dependenciesMap) =>
  maybe
    .fromNullable(dependenciesMap[filterId])
    .chain(({ controllerApi, fieldName }) =>
      maybe
        .fromNullable(controllerApi.getCurrentItem())
        .map(item => item[fieldName])
    )

const getFilterExpressionsToResolve = (filterPart, path = []) => {
  if (shouldResolve(filterPart)) {
    return [
      {
        path: path.slice(),
        filterExpression: filterPart
      }
    ]
  }

  if (Array.isArray(filterPart) || isPlainObject_(filterPart)) {
    return flatMap_(filterPart, (value, key) =>
      getFilterExpressionsToResolve(value, path.concat(key))
    )
  }

  return []
}

const resolveFilter = (filter, dependenciesMap) => {
  const filterExpressionsToResolve = getFilterExpressionsToResolve(filter)

  const resolvedExpressions = filterExpressionsToResolve.reduce(
    (acc, { filterExpression, path }) =>
      acc.concat({
        path,
        resolvedValue: getComponentValue(filterExpression, dependenciesMap)
      }),
    []
  )

  const applyResolvedValue = (filter, path, resolvedValue) =>
    resolvedValue.map(resolvedValue => set_(filter, path, resolvedValue))

  return resolvedExpressions.reduce(
    (maybeResolvedFilter, { path, resolvedValue }) =>
      maybeResolvedFilter.chain(filter =>
        applyResolvedValue(filter, path, resolvedValue)
      ),
    maybe.Just(cloneDeep_(filter))
  )
}

const extractDependencies = filter => {
  const filterExpressionsToResolve = getFilterExpressionsToResolve(filter)
  return filterExpressionsToResolve.map(
    ({ filterExpression }) => filterExpression.filterId
  )
}

module.exports.resolveFilter = resolveFilter
module.exports.extractDependencies = extractDependencies



// WEBPACK FOOTER //
// ./helpers/filters.js